'use client'

import { CategoryWithCreators } from '@/app/[locale]/(worlds)/(worlds-landing)/creators/types'
import CreatorAvatar, { CreatorAvatarSkeleton } from '@/components/CreatorAvatar'
import ViverseSkeleton from '@/components/ViverseSkeleton'
import { useWorldSearchContext } from '@/context/WorldSearchContext'
import { hasVerifiedCreatorBadge } from '@/lib/cms'
import { getTranslatedName } from '@/lib/utils'
import { useLocale } from 'next-intl'

type CreatorCategorySectionProps = {
  category: CategoryWithCreators
}

export default function CreatorCategorySection({ category }: CreatorCategorySectionProps) {
  const locale = useLocale()
  const translatedName = getTranslatedName(category.translations, locale, category.name)
  const { mobileNavHeight } = useWorldSearchContext()

  return (
    <section className="flex flex-col gap-6">
      <h2 className="header-5 md:header-4">{translatedName}</h2>
      <div
        className="flex flex-wrap gap-x-[5px] gap-y-4 md:gap-6"
        style={{ marginBottom: mobileNavHeight }}
      >
        {category.creator_recommend.map((creator) => {
          const communityUserId = creator.account?.community_user_id || ''
          const headIconUrl = creator.account?.head_icon_url || ''
          const displayName = creator.account?.display_name
          const isVerified = hasVerifiedCreatorBadge(creator.account)

          return (
            <CreatorAvatar
              key={creator.id}
              communityUserId={communityUserId}
              headIconUrl={headIconUrl}
              displayName={displayName}
              isVerified={isVerified}
            />
          )
        })}
      </div>
    </section>
  )
}

export function CreatorCategorySectionSkeleton() {
  const { mobileNavHeight } = useWorldSearchContext()

  return (
    <section className="flex flex-col gap-6">
      <ViverseSkeleton className="h-8 w-48" />
      <div className="flex flex-wrap gap-6" style={{ marginBottom: mobileNavHeight }}>
        {Array.from({ length: 5 }).map((_, cardIndex) => (
          <CreatorAvatarSkeleton key={cardIndex} />
        ))}
      </div>
    </section>
  )
}
